<div class="dip-status-container">
  @if (preloader) {
    <libero-preload-spinner></libero-preload-spinner>
  }
  @if (errored) {
    {{ 'dipLandingPage.errored' | translate }}
  }
  @if (notFoundWithToken) {
    {{ 'dipLandingPage.notFoundWithToken' | translate }}
  }
  @if (success) {
    {{ 'dipLandingPage.success' | translate }}
  }
</div>